import { Link } from "react-router-dom";
import { ArrowRight, Crown } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const ProgramsPreview = () => {
    const { t } = useLanguage();
    const P = t.previews.programs;
    const packages = t.programs.packages;

    return (
        <section
            id="programs-preview"
            data-testid="programs-preview-section"
            className="py-24 md:py-28 bg-ella-cream"
        >
            <div className="ella-container">
                <div className="max-w-2xl">
                    <span className="ella-overline" data-testid="programs-preview-overline">
                        {P.overline}
                    </span>
                    <h2
                        className="ella-headline text-4xl md:text-5xl mt-4 text-ella-ink"
                        data-testid="programs-preview-title"
                    >
                        {P.title}
                    </h2>
                    <p className="mt-5 text-ella-ink/70 font-light text-base leading-relaxed">
                        {P.lead}
                    </p>
                </div>

                <div className="mt-12 grid md:grid-cols-3 gap-5">
                    {packages.map((pkg, i) => (
                        <div
                            key={pkg.id}
                            data-testid={`programs-preview-card-${pkg.id}`}
                            className={`relative rounded-2xl border p-7 flex flex-col transition-all duration-500 ${
                                pkg.highlighted
                                    ? "bg-ella-onyx text-ella-cream border-ella-gold/40"
                                    : "bg-white border-ella-line hover:border-ella-gold/40"
                            }`}
                        >
                            {pkg.highlighted && (
                                <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 px-3 py-1 bg-ella-gold text-white text-[9px] uppercase tracking-[0.25em] rounded-full">
                                    <Crown className="w-2.5 h-2.5" strokeWidth={1.5} />
                                    {t.programs.most_popular}
                                </div>
                            )}
                            <span
                                className={`text-[10px] uppercase tracking-[0.32em] ${
                                    pkg.highlighted ? "text-ella-gold" : "text-ella-muted"
                                }`}
                            >
                                {P.items_label[i]}
                            </span>
                            <p
                                className={`font-display text-2xl mt-3 ${
                                    pkg.highlighted ? "text-ella-cream" : "text-ella-ink"
                                }`}
                            >
                                {pkg.name}
                            </p>
                            <div className="mt-4 flex items-baseline gap-2">
                                <span
                                    className={`font-display text-4xl ${
                                        pkg.highlighted ? "text-ella-champagne" : "text-ella-ink"
                                    }`}
                                >
                                    {pkg.price}
                                </span>
                                <span className="text-xs uppercase tracking-[0.22em] text-ella-gold-dark">
                                    {t.programs.currency}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-10 text-center">
                    <Link
                        to="/programme"
                        data-testid="programs-preview-cta"
                        className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-ella-ink text-ella-cream hover:bg-ella-gold-dark transition-colors text-xs uppercase tracking-[0.24em]"
                    >
                        {P.cta}
                        <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ProgramsPreview;
